import React, { Component } from 'react'
import moment from 'moment'
import uuidv4 from 'uuid/v4'
import 'moment/locale/zh-cn'
import ImageArea from '../ImageArea'
import SVG from '../SVG'
import TextToggle from '../TextToggle'
import { universalOpenUrl, formatNumber } from '../../utils'
import playBtn from '../../assets/btn-play.svg'
import answerAwardIcon from '../../assets/icon-award.svg'
import styles from './index.css'

export default class AnswerList extends Component {
  calcImageHeight = imageCount =>
    (document.body.clientWidth - imageCount - 1) /
    (375 - imageCount - 1) *
    { 1: 130, 2: 100, 3: 89 }[imageCount]

  handleClick = () => {
    const { combineProductToken, urlToken } = this.props

    universalOpenUrl(
      `https://www.zhihu.com/question/${combineProductToken}/answer/${urlToken}`
    )
  }

  render() {
    const {
      userName,
      avatar,
      pictures,
      content,
      thumbUpCount,
      comment,
      createTime,
      awards,
    } = this.props

    if (!content && (!pictures || !pictures.length)) {
      return null
    }

    return (
      <div className={styles.answerItem} onClick={this.handleClick}>
        <div className={styles.answerHeader}>
          <img src={avatar} alt="" className={styles.answerAuthorAvatar} />
          <span className={styles.answerAuthorName}>{userName}</span>
          {awards === 1 ? (
            <div className={styles.answerAwardMark}>
              <SVG src={answerAwardIcon} width={14} height={14} />
              获奖讨论
            </div>
          ) : null}
        </div>
        {Boolean(pictures && pictures.length) && (
          <div className={styles.answerImageGroup}>
            {pictures.map(picture => {
              return (
                <ImageArea
                  key={`answerimage_${uuidv4()}`}
                  className={styles.answerImageWrap}
                  style={{ height: this.calcImageHeight(pictures.length) }}
                  src={picture.url}
                >
                  {picture.type === 3 && (
                    <SVG src={playBtn} width={40} height={40} />
                  )}
                </ImageArea>
              )
            })}
          </div>
        )}
        <div className={styles.answerDetail}>
          {content && (
            <TextToggle
              className={styles.answerContent}
              content={content}
              minLength={pictures.length ? 90 : 150}
            />
          )}
          <div className={styles.answerData}>
            {`${formatNumber(thumbUpCount)}赞同 · ${formatNumber(
              comment
            )}评论 · ${moment(createTime).fromNow()}`}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/AnswerItem/index.js